import { Link } from "react-router-dom";
import { useLang } from "@/lib/i18n";

const COMMON = [["email", "email", true], ["phone", "phone", true], ["address", "address", true], ["city", "city", true], ["postal_code", "postal", true], ["country", "country", true]];
const FIELDS = {
  private: [["name", "name", true], ...COMMON],
  company: [["company", "company_name", true], ["company_code", "company_code", true], ["vat_code", "vat_code", false], ["name", "contact_person", true], ...COMMON],
};

export const EMPTY_CUSTOMER = { customer_type: "private", name: "", email: "", phone: "", company: "", company_code: "", vat_code: "", address: "", city: "", postal_code: "", country: "Lietuva", notes: "", consent: false };

export const consentMissing = (c, t, toast) => !c.consent && (toast.error(t("consent_required")), true);

export const contactValid = (c) =>
  !FIELDS[c.customer_type].some(([k, , req]) => req && c[k].trim().length < 2) && /\S+@\S+\.\S+/.test(c.email);

export const inputCls = "w-full h-11 px-3 bg-[#292D3C] border border-[#3B4157] text-sm outline-none focus:border-orange-500 transition-colors";

export function ContactFields({ c, setC, prefix = "checkout", showNotes = true }) {
  const { t } = useLang();
  return (
    <>
      <div className="sm:col-span-2 grid grid-cols-2 border border-[#3B4157]" data-testid={`${prefix}-customer-type`}>
        {["private", "company"].map((ty) => (
          <button type="button" key={ty} data-testid={`${prefix}-type-${ty}-btn`} onClick={() => setC({ ...c, customer_type: ty })}
            className={`h-11 font-display font-bold uppercase tracking-widest text-sm transition-colors ${c.customer_type === ty ? "bg-orange-500 text-[#1F2230]" : "text-slate-400 hover:text-white"}`}>
            {t(`type_${ty}`)}
          </button>
        ))}
      </div>
      {FIELDS[c.customer_type].map(([k, label, req]) => (
        <label key={k} className="text-xs uppercase tracking-wider text-slate-400 space-y-1.5">
          <span>{t(label)}{req && " *"}</span>
          <input data-testid={`${prefix}-${k}-input`} className={inputCls} value={c[k]} type={k === "email" ? "email" : "text"}
            onChange={(e) => setC({ ...c, [k]: e.target.value })} />
        </label>
      ))}
      {showNotes && (
        <label className="sm:col-span-2 text-xs uppercase tracking-wider text-slate-400 space-y-1.5">
          <span>{t("notes")}</span>
          <textarea data-testid={`${prefix}-notes-input`} rows={3} className={`${inputCls} h-auto py-2`} value={c.notes} onChange={(e) => setC({ ...c, notes: e.target.value })} />
        </label>
      )}
      <label data-testid={`${prefix}-consent`} className="sm:col-span-2 flex items-start gap-3 text-sm text-slate-300 cursor-pointer">
        <input type="checkbox" data-testid={`${prefix}-consent-checkbox`} checked={!!c.consent} onChange={(e) => setC({ ...c, consent: e.target.checked })}
          className="mt-0.5 w-4 h-4 accent-orange-500 shrink-0" />
        <span>{t("consent_1")} <Link to="/privacy" target="_blank" className="text-orange-500 underline underline-offset-2">{t("consent_privacy")}</Link> {t("consent_2")} <Link to="/terms" target="_blank" className="text-orange-500 underline underline-offset-2">{t("consent_terms")}</Link> *</span>
      </label>
    </>
  );
}
